import React from 'react';
import { Box, ChakraProvider } from '@chakra-ui/react';
import { theme } from './utils/theme';
import { useTawkTo } from './hooks/useTawkTo';
import { usePageMeta } from './hooks/usePageMeta';
import { useGoogleTagManager, GTM_NOSCRIPT_SRC } from './hooks/useGoogleTagManager';
import { SideNav } from './components/SideNav';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { WhyUs } from './components/WhyUs';
import { About } from './components/About';
import { Gallery } from './components/Gallery';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  usePageMeta();
  useGoogleTagManager();
  useTawkTo();
  return <ChakraProvider theme={theme} data-id="element-0" data-mp="28u5xmlt5v3cb">
      <noscript data-id="element-1" data-mp="28t4m6g88geu2">
        <iframe src={GTM_NOSCRIPT_SRC} height="0" width="0" style={{
        display: 'none',
        visibility: 'hidden'
      }} title="Google Tag Manager" data-id="element-2" data-mp="28sur4e8bzhhi" />
      </noscript>
      <Box w="100%" minH="100vh" bg="ink.900" overflowX="hidden" data-id="element-3" data-mp="3ihv2ugmu8pjx">
        <SideNav data-id="element-4" data-mp="3mk8710lxsfel" />
        <Box as="main" pt={{
        base: '4.75rem',
        lg: 0
      }} data-id="element-5" data-mp="3mjq1tehaqquj">
          <Hero data-id="element-6" data-mp="3rbrcwx2qabiz" />
          <Services data-id="element-7" data-mp="3rdatkosaqola" />
          <WhyUs data-id="element-8" data-mp="3rd1azm9kzjpm" />
          <About data-id="element-9" data-mp="3reltgdimfc74" />
          <Gallery data-id="element-10" data-mp="5ot150vj28n" />
          <Testimonials data-id="element-11" data-mp="67yvnd9206b" />
          <Contact data-id="element-12" data-mp="5gez9t0lqvv" />
        </Box>
        <Footer data-id="element-13" data-mp="7st1bvnjh3n" />
      </Box>
    </ChakraProvider>;
}